<template>
  <div class="position-relative">
    <BaseTopLine> </BaseTopLine>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[1300px]"
      >
        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">
            {{ dataLang["reestr_objects_archive_text5"] }}
          </label>
          <BaseSelect
            v-model="filters.objects_types.value"
            :customLabel="
              ({ vehicle_types__code }) => {
                return dataLang[vehicle_types__code];
              }
            "
            id="ads__id"
            :maxHeight="330"
            :options="objectsTypesFiltered"
            placeholder=""
            selectLabel=""
            deselectLabel=""
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">RIN</label>
          <BaseInputNew
            inputClass="tw-app-input-dark"
            :inputStyle="{ width: '100%' }"
            @input="filters.rin.value = $event.value"
            :value="filters.rin.value"
            inputName="vehicles__id"
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["reestr_objects_archive_text7"] }}
          </label>
          <BaseInputNew
            inputClass="tw-app-input-dark"
            @input="filters.vehicles__name.value = $event.value"
            :value="filters.vehicles__name.value"
            inputName="vehicles__name"
          />
        </div>

        <div class="tw-flex tw-flex-row">
          <button @click="toFilter()" class="tw-app-btn-primary">
            {{ dataLang["reestr_objects_archive_text3"] }}
          </button>
          <button
            @click="resetFilter()"
            class="tw-app-btn-light tw-text-nowrap"
          >
            {{ dataLang["reestr_objects_archive_text4"] }}
          </button>
        </div>
      </div>
    </div>

    <div>
      <BaseLoader v-if="localLoading"></BaseLoader>

      <div
        class="tw-px-[26px] tw-mt-[15px] tw-flex tw-items-center tw-gap-[10px]"
      >
        <button
          class="tw-app-btn-primary-outline"
          @click="deleteActionAndModal"
        >
          <img
            :src="require(`@/assets/icons/adddel.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["reestr_objects_archive_text1"] }}
        </button>
        <button
          class="tw-app-btn-primary-outline"
          @click="onShowModalForRestore"
        >
          <img
            :src="require(`@/assets/icons/document-previous.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["reestr_objects_archive_text2"] }}
        </button>
      </div>

      <div class="tw-px-[26px] tw-py-[15px]">
        <ve-table
          class="fixed-header rest-style-table"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTableFiltered"
          :border-x="true"
          :border-y="true"
          row-key-field-name="vehicles__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          v-if="!localLoading"
          :radio-option="{
            selectedRowChange: selectedRowChange,
          }"
          :clickHighlight="false"
          :cell-style-option="{}"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>
    <BaseModal
      name="acceptDelete"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('acceptDelete')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">
            {{ dataLang.confirm_dialog_delete }}
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptDelete')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="deleteRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Выполнить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal
      name="acceptDeleteWithPin"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="pincodeModalHandler"
      :adaptive="true"
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        v-if="localLoading"
        class="position-absolute wp-100 h-100 d-flex justify-content-center align-items-center bg-white"
        style="top: 0; left: 0; z-index: 500"
      >
        <svg class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </div>
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('acceptDeleteWithPin')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">Внимание!</div>
          <div class="tw-my-[15px]">Введите пароль администратора!</div>
          <BaseInputNew
            inputClass="tw-app-input-type-3 tw-mb-[15px]"
            placeholder=""
            :input-name="'pincode'"
            @input="(data) => (pincode = data.value)"
            value=""
            name-sign=""
          >
          </BaseInputNew>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptDeleteWithPin')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="deleteRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <template>
      <BaseModal
        name="modalForRestore"
        width="420"
        height="auto"
        :clickToClose="false"
        :shiftY="0.5"
        @before-close="onCloseModalForRestore"
        :adaptive="true"
        classes="!tw-bg-transparent !tw-shadow-none"
      >
        <div
          class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle tw-min-h-[300px] tw-flex tw-justify-center tw-items-center"
        >
          <BaseLoader
            v-if="localLoadingModal"
            class="tw-rounded-[25px]"
          ></BaseLoader>

          <button
            type="button"
            class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
            @click="$modal.hide('modalForRestore')"
          ></button>

          <div class="tw-text-center">
            <div class="tw-text-[23px] tw-mb-[15px]">
              {{ dataLang["reestr_objects_archive_text12"] }}
            </div>

            <div v-if="selectsDataForModal.places.length">
              <div class="multiselect-type-3-label">
                {{ dataLang["reestr_objects_archive_text13"] }}
              </div>
              <BaseSelect
                class="multiselect-type-3"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                openDirection="bottom"
                v-model="selectsFromModal.places"
                :options="selectsDataForModal.places"
                :maxHeight="100"
                label="vehicle_places__name"
                :optionHeight="25"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>
            <div v-else class="tw-h-[10px]"></div>

            <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
              <button
                @click="$modal.hide('modalForRestore')"
                class="tw-app-btn-muted tw-app-btn-muted-lg"
              >
                {{ dataLang["reestr_objects_archive_text14"] }}
              </button>
              <button
                @click="onSaveObjectFromArchive"
                class="tw-app-btn-primary tw-app-btn-primary-lg"
              >
                {{ dataLang["reestr_objects_archive_text2"] }}
              </button>
            </div>
          </div>
        </div>
      </BaseModal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";

export default {
  components: {
    VeTable,
  },

  data() {
    return {
      filters: {
        rin: {
          value: null,
        },
        objects_types: {
          value: null,
        },
        vehicles__name: {
          value: null,
        },
      },
      localLoading: true,
      dataTable: [],
      dataTableFiltered: [],
      activeSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      nameValue: "",
      activePagePagination: {},
      currentId: null,
      localLoadingModal: false,
      pincode: "",
      copiedDataForFilter: [],
      selectsDataForModal: {
        places: [],
      },
      selectsFromModal: {
        places: [],
      },
      selectsData: {
        objects_types: [],
      },
      selectsFilter: { objects_types: [] },
      eventCustomOption: {},
      filterParams: {},
    };
  },
  methods: {
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = [row.vehicles__id];
    },
    saveIntegrator() {},

    // @before-close="onCloseModalForRestore"
    //     @before-open="onShowModalForRestore"

    onCloseModalForRestore() {
      this.selectsDataForModal.places = [];
      this.selectsFromModal.places = [];
      this.activeSelectRowsMultiple = [];
      this.loadData();
    },

    onShowModalForRestore() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("modalForRestore");
      } else {
        this.$toast.error(this.dataLang["reestr_objects_archive_text15"], {
          duration: 5000,
        });
      }
    },

    onSaveObjectFromArchive() {
      this.localLoadingModal = true;
      GeneralService.edit(
        `/objects/fromarchive/${this.activeSelectRowsMultiple[0]}`,
        {
          ...(this.selectsFromModal && {
            vehicles__place_id: this.selectsFromModal.places.vehicle_places__id,
          }),
        }
      )
        .then((data) => {
          if ("places" in data.data.data) {
            this.$toast.info(data.data.message);
            this.selectsDataForModal.places = data.data.data.places;
          } else {
            this.$modal.hide("modalForRestore");
            this.$toast.success(data.data.message);
          }
          this.localLoadingModal = false;
        })
        .catch((e) => {
          this.localLoadingModal = false;
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;

      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },

    resetFilter() {
      this.filters = {
        rin: {
          value: null,
        },
        objects_types: {
          value: null,
        },
        vehicles__name: {
          value: null,
        },
      };
      this.toFilter();
    },

    createorEdit() {
      if (this.currentId) {
        GeneralService.edit(`/integrators/${this.currentId}`, {
          ...this.updatedValues,
        })
          .then((data) => {
            this.$modal.hide("addIntegrator");
            this.loadData(1);
          })
          .catch((e) => {
            this.loadData(1);
          });
      } else {
        GeneralService.editOrCreate(`/integrators`, {
          ...this.updatedValues,
        })
          .then((data) => {
            this.$modal.hide("addIntegrator");
            this.loadData(1);
          })
          .catch((e) => {
            this.loadData(1);
          });
      }
    },

    // On click
    // Navigate to: "Авторизация / Данные введены";
    // Animate: Smart animate;
    // Spring: { mass: 1, stiffness: 400, damping: 30 };

    closemodal() {
      this.currentId = null;
      this.updatedValues = {};
      this.activeSelectRowsMultiple = [];
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$toast.error(this.dataLang["reestr_objects_archive_text15"], {
          duration: 5000,
        });
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
    },
    deleteRow(nameModal) {
      GeneralService.delete(`/objects/` + this.activeSelectRowsMultiple, {
        ...(this.pincode && { pincode: this.pincode }),
      })
        .then((data) => {
          this.loadData();

          this.$toast.success(data.data.message);
          this.$modal.hide("acceptDeleteWithPin");
          this.$modal.hide("acceptDelete");
        })
        .catch((e) => {
          if (e.response.status == 409) {
            this.$modal.show("acceptDeleteWithPin");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          } else if (e.response.status == 400) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },
    loadData() {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/objects/types`)
          .then((data) => {
            // this.selects.push(data.data.data.rows)
            this.selectsData = Object.assign(this.selectsData, {
              objects_types: data.data.data.rows,
            });
          })
          .catch((e) => {}),
      ]).then(() => {
        GeneralService.get(`/objects/table/archive`)
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.dataTableFiltered = data.data.data.rows;
            this.copiedDataForFilter = data.data.data.rows;
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка", { duration: 5000 });
          });
      });
    },
    toFilter() {
      this.dataTableFiltered = this.dataTable;
      if (this.filters.objects_types.value?.vehicle_types__code) {
        this.dataTableFiltered = this.dataTable.filter(
          (i) =>
            i.vehicle_types__code ==
            this.filters.objects_types.value.vehicle_types__code
        );
      }
      if (this.filters.rin.value) {
        this.dataTableFiltered = this.dataTableFiltered.filter(
          (i) => String(i.vehicles__id) == String(this.filters.rin.value)
        );
      }
      if (this.filters.vehicles__name.value) {
        this.dataTableFiltered = this.dataTableFiltered.filter((i) =>
          i.vehicles__name
            ?.toLowerCase()
            ?.includes(this.filters.vehicles__name.value?.toLowerCase())
        );
      }
    },
    fillFilter(data) {
      console.log(data);
      this.filterParams[data.name] = String(data.value);
      if (data.value.length) {
        // this.filterParams[data.name]
        this.dataTableFiltered = this.dataTable.filter((x) => {
          return (
            String(x[data.name]).toLowerCase() ==
              String(data.value).toLowerCase() ||
            String(x[data.name])
              .toLowerCase()
              .includes(String(data.value).toLowerCase())
          );
        });
      } else {
        delete this.filterParams[data.name];
        this.dataTableFiltered = this.copiedDataForFilter;
      }
    },
  },
  mounted() {},
  created() {
    Promise.all([
      //   }),
    ]).then(() => {
      this.loadData();
      //   GeneralService.editOrCreate(`/integrators`, {
      //     integrators__company_id: 1,
      //     integrators__percent: 2
      //   })
      //     .then((data) => {
      //
      //     })
      //     .catch((e) => {
      //
      //       this.$toast.error('Неизвестная ошибка', {duration: 5000})
      //     })
    });
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    columns() {
      return [
        {
          field: "",
          key: "a",

          type: "radio",
          title: "",
          width: 5,
          align: "center",
        },
        {
          field: "vehicle_types__code",
          key: "12",
          title: this.dataLang["reestr_objects_archive_text5"],
          align: "center",
          width: "25%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return this.dataLang[row.vehicle_types__code];
          },
          // renderHeaderCell: ({ column }, h) => {
          //   return (
          //     <div>
          //       <div class={"text-center"}>{column.title}</div>
          //       <BaseSelect
          //         vModel={this.selectsFilter.objects_types}
          //         onInput={(e, w) => {
          //           this.fillFilter({
          //             value: e.vehicle_types__code,
          //             name: "vehicle_types__code",
          //           });
          //         }}
          //         style={"width: 100%"}
          //         customLabel={({ vehicle_types__code }) => {
          //           return this.dataLang[vehicle_types__code];
          //         }}
          //         placeholder={""}
          //         id={"ads__id"}
          //         selectLabel={""}
          //         deselectLabel={""}
          //         options={this.selectsData.objects_types}
          //       ></BaseSelect>
          //     </div>
          //   );
          // },
        },

        {
          field: "vehicles__id",
          key: "13",
          title: "RIN",
          align: "center",
          width: "12%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          // renderHeaderCell: ({ column }, h) => {
          //   return (
          //     <div>
          //       <div class={"text-center"}>{column.title}</div>

          //       <BaseInputNew
          //         placeholder=""
          //         style={"width: 100%"}
          //         disabled={false}
          //         onInput={this.fillFilter}
          //         inputName={"vehicles__id"}
          //         value={""}
          //         nameSign={""}
          //       />
          //     </div>
          //   );
          // },
        },
        {
          field: "vehicles__name",
          key: "132",
          title: this.dataLang["reestr_objects_archive_text7"],
          align: "center",
          width: "12%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          // renderHeaderCell: ({ column }, h) => {
          //   return (
          //     <div>
          //       <div class={"text-center"}>{column.title}</div>

          //       <BaseInputNew
          //         placeholder=""
          //         style={"width: 100%"}
          //         disabled={false}
          //         onInput={this.fillFilter}
          //         inputName={"vehicles__name"}
          //         value={""}
          //         nameSign={""}
          //       />
          //     </div>
          //   );
          // },
        },
        {
          field: "vehicles__year_release",
          key: "133",
          title: this.dataLang["reestr_objects_archive_text8"],
          align: "center",
          width: "12%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "vehicles__created_at",
          key: "134",
          title: this.dataLang["reestr_objects_archive_text9"],
          align: "center",
          width: "12%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.vehicles__created_at
                  ? this.$time(row.vehicles__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "vehicles__archived_at",
          key: "135",
          title: this.dataLang["reestr_objects_archive_text10"],
          align: "center",
          width: "12%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.vehicles__archived_at
              ? this.$time(row.vehicles__archived_at).format(
                  `${this.userSetting.company__tempalte_date}`
                )
              : "";
          },
        },
        {
          field: "vehicles__active_duration",
          key: "136",
          title: this.dataLang["reestr_objects_archive_text11"],
          align: "center",
          width: "12%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
      ];
    },
    objectsTypesFiltered() {
      let availableType = ["car", "water", "air"];
      let sortedVehicles = availableType.reduce((result, typeCode) => {
        let found = this.selectsData.objects_types.find(
          (i) => i.vehicle_types__code === typeCode
        );
        if (found) {
          result.push(found);
        }
        return result;
      }, []);
      return sortedVehicles;
    },
  },
};
</script>

<style>
.client-status-danger {
  background-color: #ff2400 !important;
  color: white !important;
}
</style>
